import { TicketWithSaleTickets, TicketWithSpots } from "../global-commons/type";
/** 軽量キーバリューストア本体 */
class ApiCache<T> {
  private cache: Record<number, T>;

  constructor() {
    this.cache = {};
  }

  get(key: number): T | undefined {
    return this.cache[key];
  }

  set(key: number, value: T): void {
    this.cache[key] = value;
  }

  delete(key: number): void {
    delete this.cache[key];
  }

  clear(): void {
    this.cache = {};
  }
}

export const saleTicketFromSpotCache = new ApiCache<TicketWithSaleTickets[]>();
export const spotFromSaleTicketCache = new ApiCache<TicketWithSpots[]>();
